import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Status } from '../../store/models/europrisme';
import { Colors } from '../../styles/vars';
import { connect } from '../../utils/redux';
import Spinner from './Spinner';

const LoaderContainer = styled(motion.div)`
  position: fixed;
  display: grid;
  place-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${Colors.white};

  z-index: 950;
`;

const MultiAccountLoader = ({
  currentUser,
  isSwitchingMultiAccountCurrentUser,
  workerStatus,
}) => {
  const shouldShowLoader =
    currentUser &&
    currentUser.isMultiAccount &&
    workerStatus === Status.LOADING &&
    isSwitchingMultiAccountCurrentUser;

  return (
    <AnimatePresence>
      {shouldShowLoader && (
        <LoaderContainer
          key="multi-account-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <Spinner
            style={{ color: Colors.primary }}
            messageStyle={{ color: Colors.accent }}
            messages={[
              'Veuillez patienter pendant le changement de compte client',
              'Chargement des rayons et familles de produits…',
              'Chargement du catalogue de produits…',
              'Chargement du moteur de recherche…',
            ]}
            messageDelay={15}
            instantInitialMessage
          />
        </LoaderContainer>
      )}
    </AnimatePresence>
  );
};

MultiAccountLoader.propTypes = {
  currentUser: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    v => v === null,
  ]),

  isSwitchingMultiAccountCurrentUser: PropTypes.bool,
  workerStatus: PropTypes.string.isRequired,
};

MultiAccountLoader.defaultProps = {
  currentUser: null,
  isSwitchingMultiAccountCurrentUser: false,
};

export default connect(
  state => ({ ...state.products, ...state.users }),
  {},
)(MultiAccountLoader);
